
// import React from "react";
// import {
//   Box,
//   Button,
//   Tabs,
//   Tab,
//   FormControlLabel,
//   Checkbox,
//   Popover,
// } from "@mui/material";

// interface FilterDropdownProps {
//   anchorEl: HTMLElement | null;
//   onClose: () => void;
//   onApply: (selectedFilters: Record<string, boolean>) => void;
//   tabsConfig: { 
//     key: string;
//      label: string;
//       options: string[]
//      }[]; 
// }
// const FilterDropdown: React.FC<FilterDropdownProps> = ({ anchorEl, onClose, onApply ,  tabsConfig,}) => {
//   const [currentTab, setCurrentTab] = React.useState(0);
//   const [checkedOptions, setCheckedOptions] = React.useState<Record<string, boolean>>({});



//   const isOpen = Boolean(anchorEl);

//   const onTabChange = (_: React.SyntheticEvent, value: number) => {
//     setCurrentTab(value);
//   };

//   const handleCheckboxChange = (option: string) => {
//     setCheckedOptions((prev) => ({
//       ...prev,
//       [option]: !prev[option],
//     }));
//   };

//   const clearAllFilters = () => {
//     setCheckedOptions({});
//   };

//   const applyFilters = () => {
//     onApply(checkedOptions);
//     onClose();
//   };

//   return (
//     <Box sx={{maxWidth:"100% !important"}}>
//     <Popover
//       open={isOpen}
//       anchorEl={anchorEl}
//       onClose={onClose}
//       anchorOrigin={{
//         vertical: "bottom",
//         horizontal: "right",
//       }}
//       transformOrigin={{
//         vertical: "top",
//         horizontal: "right",
//       }}
//       sx={{ width: "440px", maxWidth: "100% !important" }} 
//     >
//       <Box sx={{ padding: "16px", width: "440px",maxWidth:"100% " }}>
//         {/* Vertical Tabs and Filter Content */}
//         <Box sx={{  display: "flex", }}>
//           {/* Tabs Section */}
//           <Box sx={{ width: "50%",height: "259px",overflowY:"auto", borderRight: "1px solid #ddd" }}>
//             <Tabs
//               orientation="vertical"
//               value={currentTab}
//               onChange={onTabChange}
//               aria-label="Filter tabs"
//               sx={{
//                 borderRight: 1,
//                 borderColor: "divider",
//                 whiteSpace: "nowrap",
//                 fontSize: "14px",
//                 color: "#282829",
//                 fontWeight: "500",
//                 textAlign: "left",
//               }}
//             >
//               {tabsConfig.map((tab) => (
//                 <Tab key={tab.key} label={tab.label} sx={tabStyles} />
//               ))}
//             </Tabs>
//           </Box>

//           {/* Tab Content */}
//           <Box sx={{ paddingLeft: "20px",width: "50%", flexGrow: 1 ,height: "259px",overflowY:"auto",}}>
//             {tabsConfig.map((tab, index) =>
//               currentTab === index ? (
//                 <Box key={tab.key} sx={{ marginBottom: "16px" }}>
//                   {tab.options.map((option) => (
//                     <FormControlLabel
//                       key={option}
//                       // sx={{ display: "block" }}
//                       control={
//                         <Checkbox
//                           checked={!!checkedOptions[option]}
//                           onChange={() => handleCheckboxChange(option)}
//                         />
//                       }
//                       label={option}
//                     />
//                   ))}
//                 </Box>
//               ) : null
//             )}
//           </Box>
//         </Box>

//         {/* Clear and Apply Buttons */}
//         <Box
//           sx={{

//             width: "100%",
//             justifyContent: "end",
//             display: "flex",
//             borderTop: "1px solid #ddd",
//             paddingTop: "10px",
//           }}
//         >
//           <Button sx={clearButtonStyles} onClick={clearAllFilters}>
//             Clear All
//           </Button>
//           <Button sx={applyButtonStyles} onClick={applyFilters}>
//             Apply
//           </Button>
//         </Box>
//       </Box>
//     </Popover>
//     </Box>
//   );
// };

// const tabStyles = {
//   whiteSpace: "nowrap",
//   fontSize: "14px",
//   color: "#282829",
//   fontWeight: "500",
//   textTransform: "capitalize",
//   alignItems: "start",
//   "&:hover": { backgroundColor: "#F9FBFC" },
//   "&.Mui-selected": { backgroundColor: "#F9FBFC", color: "#000" },
// };

// const clearButtonStyles = {
//   border: "1px solid #E7E8E9",
//   color: "#000",
//   marginRight: "10px",
//   borderRadius: "10px",
//   textTransform: "capitalize",
//   height: "44px",
//   padding: "15px 15px",
// };

// const applyButtonStyles = {
//   border: "1px solid #C8172F",
//   color: "#C8172F",
//   borderRadius: "10px",
//   height: "44px",
//   padding: "15px 15px",
// };

// export default FilterDropdown;
import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Tabs,
  Tab,
  FormControlLabel,
  Checkbox,
  Popover,
} from "@mui/material";
import { getalllocations, getalltasktype } from "../../pages/reports/api";
import { getalloutlettype } from "../../pages/assign-task/api";
import { useNavigate, useParams } from "react-router-dom";

interface FilterDropdownProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onApply: (selectedFilters: Record<string, { option: string; label: string }>) => void;
  locationsLabel11: string[];
  outletLabel22: string[];
  setLocationsLabel: React.Dispatch<React.SetStateAction<string[]>>;
  setOutletLabel: React.Dispatch<React.SetStateAction<string[]>>;
  tabsConfig1: {
    key: string;
    label: string;
    options: string[];
  }[];
}

const FilterDropdown: React.FC<FilterDropdownProps> = ({
  anchorEl,
  onClose,
  onApply,
  tabsConfig1,
  locationsLabel11,
  outletLabel22,
  setLocationsLabel,

  setOutletLabel,
  
}) => {
  const [currentTab, setCurrentTab] = useState(0);
  const [checkedOptions, setCheckedOptions] = useState<Record<string, { option: string; label: string }>>({});
  const [tabsConfig, setTabsConfig] = useState(tabsConfig1);
  const navigate = useNavigate();
  const { id } = useParams();
  const isOpen = Boolean(anchorEl);

  const onTabChange = (_: React.SyntheticEvent, value: number) => {
    setCurrentTab(value);
  };

  // const handleCheckboxChange = (option: string, label: string) => {
  //   setCheckedOptions((prev) => {
  //     const isChecked = !!prev[option];
  //     if (isChecked) {
  //       const { [option]: _, ...rest } = prev; 
  //       return rest;
  //     } else {
  //       return { ...prev, [option]: { option, label } }; 
  //     }
  //   });
  // };
  const handleCheckboxChange = (option: string, label: string, optionsInTab: string[]) => {
    const isSelectAll = option.toLowerCase().includes("all");

    if (isSelectAll) {
      const isAllSelected = optionsInTab.every(
        (opt) => checkedOptions[opt]
      );

      const newCheckedOptions = { ...checkedOptions };
      optionsInTab.forEach((opt) => {
        if (isAllSelected) {
          delete newCheckedOptions[opt];
        } else {
          newCheckedOptions[opt] = { option: opt, label };
        }
      });

      setCheckedOptions(newCheckedOptions);
    } else {
      setCheckedOptions((prev) => {
        const isChecked = !!prev[option];
        if (isChecked) {
          const { [option]: _, ...rest } = prev;
          return rest;
        } else {
          return { ...prev, [option]: { option, label } };
        }
      });
    }
  };


  // const [locationsLabel11, setLocationsLabel] = useState<string[]>([]);
  // const [outletLabel22, setOutletLabel] = useState<string[]>([]);

  // useEffect(() => {
  //   const updatedLocationsLabel = Object.values(checkedOptions)
  //     .filter((item) => item.label === "Location")
  //     .map((item) => item.option);

  //   const updatedOutletLabel = Object.values(checkedOptions)
  //     .filter((item) => item.label === "Outlet Type")
  //     .map((item) => item.option);

  //   setLocationsLabel(updatedLocationsLabel);
  //   setOutletLabel(updatedOutletLabel);
  // }, [checkedOptions]);





  const clearAllFilters = () => {
    setCheckedOptions({});
  };



  const applyFilters = () => {
    const selectedLocations = Object.values(checkedOptions)
      .filter((item) => item.label === "Location")
      .map((item) => item.option);

    const selectedOutlets = Object.values(checkedOptions)
      .filter((item) => item.label === "Outlet Type")
      .map((item) => item.option);
    setLocationsLabel(selectedLocations);
    setOutletLabel(selectedOutlets);


    onApply(checkedOptions);
    onClose();
  };



  const prevSelectedlocations = useRef(outletLabel22);
  useEffect(() => {
    if (
      outletLabel22.length > 0 &&
      JSON.stringify(outletLabel22) !== JSON.stringify(prevSelectedlocations.current)
    ) {
      console.log(
        outletLabel22,
        "selectedLocations55"
      );
      navigate(`/assign-task/${id}`, {
        state: { outletLabeloutletLabeloutletLabel4546: outletLabel22 },
      });
      prevSelectedlocations.current = outletLabel22;
    }
  }, [outletLabel22]);

  const prevSelectedoutelet = useRef(locationsLabel11);
  useEffect(() => {
    if (
      locationsLabel11.length > 0 &&
      JSON.stringify(locationsLabel11) !== JSON.stringify(prevSelectedoutelet.current)
    ) {
      console.log(
        locationsLabel11,
        "selectedLocations55"
      );
      navigate(`/assign-task/${id}`, {
        state: { locationsLabellocationsLabel3443645: locationsLabel11 },
      });
      prevSelectedoutelet.current = locationsLabel11;
    }
  }, [locationsLabel11]);

  useEffect(() => {
    if (currentTab === 0) {
      const fetchOutletTypes = async () => {
        try {
          const response = await getalloutlettype();
          const outletTypes = response.data.data || [];
          const updatedOutletTypes = ["All Outlet Types", ...outletTypes];

          setTabsConfig((prevConfig) =>
            prevConfig.map((tab) =>
              tab.key === "tab0" ? { ...tab, options: updatedOutletTypes } : tab
            )
          );
        } catch (error) {
          console.error("Error fetching outlet types:", error);
        }
      };

      fetchOutletTypes();
    }
  }, [currentTab]);

  useEffect(() => {
    if (currentTab === 1) {
      const fetchLocations = async () => {
        try {
          const response = await getalllocations();
          const locations = response.data.data || [];
          const updatedLocations = ["All Locations", ...locations];

          setTabsConfig((prevConfig) =>
            prevConfig.map((tab) =>
              tab.key === "tab1" ? { ...tab, options: updatedLocations } : tab
            )
          );
        } catch (error) {
          console.error("Error fetching locations:", error);
        }
      };

      fetchLocations();
    }
  }, [currentTab]);

  // useEffect(() => {
  //   if (currentTab === 3) {
  //     const fetchLocations = async () => {
  //       try {
  //         const response = await getalltasktype();
  //         const locations = response.data.data || [];
  //         const updatedLocations = ["All Task Type", ...locations];

  //         setTabsConfig((prevConfig) =>
  //           prevConfig.map((tab) =>
  //             tab.key === "tab3" ? { ...tab, options: updatedLocations } : tab
  //           )
  //         );
  //       } catch (error) {
  //         console.error("Error fetching locations:", error);
  //       }
  //     };

  //     fetchLocations();
  //   }
  // }, [currentTab]);


  console.log(checkedOptions, "checkedOptionscheckedOptionseee")
  console.log(currentTab, "currentTabsssssssssss")
  return (
    <Box sx={{ maxWidth: "100% !important" }}>
      <Popover
        open={isOpen}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        sx={{
          width: "440px", maxWidth: "100% !important",

          "& .MuiPaper-elevation": {
            borderRadius: "10px",
          }
        }}

      >
        <Box sx={{ padding: "16px 0", width: "480px", maxWidth: "100% ", }}>
          {/* Vertical Tabs and Filter Content */}
          <Box sx={{ display: "flex" }}>
            {/* Tabs Section */}
            <Box
              sx={{
                width: "50%",
                height: "259px",
                overflowY: "auto",
                borderRight: "1px solid #ddd",
              }}
            >
              <Tabs
                orientation="vertical"
                value={currentTab}
                onChange={onTabChange}
                aria-label="Filter tabs"
                sx={{
                  borderRight: 1,
                  borderColor: "divider",
                  whiteSpace: "nowrap",
                  fontSize: "14px",
                  color: "#282829",
                  fontWeight: "500",
                  textAlign: "left",
                }}
              >
                {tabsConfig.map((tab) => (
                  <Tab key={tab.key} label={tab.label} sx={tabStyles} />
                ))}
              </Tabs>
            </Box>

            {/* Tab Content */}
            <Box
              sx={{
                paddingLeft: "20px",
                width: "50%",
                flexGrow: 1,
                height: "259px",
                overflowY: "auto",
              }}
            >
              {tabsConfig.map((tab, index) =>
                currentTab === index ? (
                  <Box key={tab.key} sx={{ marginBottom: "16px" }}>
                    {tab.options.map((option) => (
                      <FormControlLabel style={{ display: "block" }}
                        key={option}
                        control={
                          <Checkbox
                            checked={!!checkedOptions[option]}
                            onChange={() => handleCheckboxChange(option, tab.label, tab.options)}
                          />
                        }
                        label={option}
                      />
                    ))}
                  </Box>
                ) : null
              )}
            </Box>
          </Box>

          {/* Clear and Apply Buttons */}
          <Box
            sx={{
              width: "100%",
              justifyContent: "end",
              display: "flex",
              borderTop: "1px solid #ddd",
              paddingTop: "10px",
            }}
          >
            <Button sx={clearButtonStyles} onClick={clearAllFilters}>
              Clear All
            </Button>
            <Button sx={applyButtonStyles} onClick={applyFilters} style={{ marginRight: "20px" }}>
              Apply
            </Button>
          </Box>
        </Box>
      </Popover>
    </Box>
  );
};

const tabStyles = {
  whiteSpace: "nowrap",
  fontSize: "14px",
  color: "#282829",
  fontWeight: "500",
  textTransform: "capitalize",
  alignItems: "start",
  "&:hover": { backgroundColor: "#F9FBFC" },
  "&.Mui-selected": { backgroundColor: "#F9FBFC", color: "#000" },
};

const clearButtonStyles = {
  border: "1px solid #E7E8E9",
  color: "#000",
  marginRight: "10px",
  borderRadius: "10px",
  textTransform: "capitalize",
  height: "44px",
  padding: "15px 15px",
};

const applyButtonStyles = {
  border: "1px solid #C8172F",
  color: "#C8172F",
  borderRadius: "10px",
  height: "44px",
  padding: "15px 15px",
};

export default FilterDropdown;